// extracted by mini-css-extract-plugin
export var background = "_5g-0";
export var container = "_5g-1";
export var contentItem = "_5g-7";
export var extendedWarranty = "_5g-5";
export var link = "_5g-d";
export var modal = "_5g-b";
export var modalCloseButton = "_5g-9";
export var modalContent = "_5g-3";
export var modalContentMain = "_5g-6";
export var modalImageLogo = "_5g-8";
export var modalLogo = "_5g-a";
export var modalSideImage = "_5g-4";
export var preview = "_5g-c";
export var redoModal = "_5g-2";